import { render } from "./TopCurrencies.vue?vue&type=template&id=c606b89a&scoped=true"
import script from "./TopCurrencies.vue?vue&type=script&lang=js"
export * from "./TopCurrencies.vue?vue&type=script&lang=js"

import "./TopCurrencies.vue?vue&type=style&index=0&id=c606b89a&scoped=true&lang=css"

import exportComponent from "/Users/opeculiar/Downloads/www/tzraffles/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c606b89a"]])

export default __exports__